const theme = {
    codanColors: {
        color: '#FFB600',
        colorHover: '#EFA310',
        codanBlue: '#050faa',
        codanErrorRed: '#C43232',
        black: '#2e2e35'
    },
    buttonColor: {
        default: '#FFA500',
        hover: '#E39402'
    },
    fontSize: {
        small: '1rem',
        medium: '2rem',
        large: '3rem'
    },
    mediaQueries: {
        small: '@media (min-width: 576px)',
        medium: '@media (min-width: 768px)',
        large: '@media (min-width: 992px)',
        extraLarge: '@media (min-width: 1200px)'
    }
    
}

export default theme;